import React from 'react';
import { Box } from '@mui/material';
import IconSvg from '../../assets/icons/Icon.svg';

const Logo = ({ size = '32px' }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mr: '10px'}}>
      <img 
        src={IconSvg} 
        alt="NanoTradingCopilot Logo" 
        style={{ 
          height: size, 
          width: 'auto' 
        }} 
      />
    </Box>
  );
};

export default Logo; 